import { render, staticRenderFns } from "./constractorsForm.vue?vue&type=template&id=08dedcf0&scoped=true&"
import script from "./constractorsForm.vue?vue&type=script&lang=js&"
export * from "./constractorsForm.vue?vue&type=script&lang=js&"
import style0 from "./constractorsForm.vue?vue&type=style&index=0&id=08dedcf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dedcf0",
  null
  
)

export default component.exports